import { devError, isFn } from '@ecom-zform/shared';
var PubSub = /** @class */ (function () {
    function PubSub() {
        this._subscriber = [];
        this._index = 0;
    }
    PubSub.prototype.subscribe = function (callback) {
        var _this = this;
        devError(isFn(callback), 'cycle', 'callback should be a function');
        var i = this._index;
        this._subscriber[i] = callback;
        this._index++;
        return function () {
            delete _this._subscriber[i];
        };
    };
    PubSub.prototype.notify = function (payload) {
        this._subscriber.forEach(function (callback) { return callback(payload); });
    };
    return PubSub;
}());
export { PubSub };
